<script>
  import { navigate, useLocation } from "svelte-navigator";

  const location = useLocation()

	function backClicked() {
		navigate(-1);
	}

  console.log("Loc", $location.pathname)
</script>

{#if $location.pathname.startsWith('/flights') && $location.pathname.split('/').length > 2}
  <div class="hoverIconEffect"><img src="/images/arrow-left-white.svg" alt="Settings slider icon" width="24 px" height="24 px" on:click={backClicked}/></div>
{/if}

<style>
  .hoverIconEffect {
    margin-right:8px;
    display: none;
  }

  @media only screen and (max-width: 600px) {
    .hoverIconEffect {
      display: initial;
    }
  }
</style>